import React, { Component } from 'react';

export default class Portfolio extends Component {
  onClickNotes() {
    window.location.href = 'https://dvq9mc3l8kp03.cloudfront.net/';
  }

  render() {
    return (
      <React.Fragment>
        <section id="portfolio" className="s-portfolio target-section">
          <div className="row s-portfolio__header">
            <div className="column large-12">
              <h3>A Few Of My Latest Projects</h3>
            </div>
          </div>
          <div
            className="row collapse block-large-1-4 block-medium-1-3 block-tab-1-2 block-500-stack folio-list"
            style={{ gridColumnGap: '35%', justifyContent: 'center' }}
          >
            <div className="column folio-item">
              <p className="resume-block__header-meta">
                <span>Notes App (AWS, React, Serverless)</span>
              </p>
              <div
                onClick={() => this.onClickNotes()}
                className="folio-item__thumb"
              >
                <img
                  style={{ width: '100%', height: '100%' }}
                  src="images/portfolio/notes192.png"
                  srcSet="images/portfolio/notes192.png 1x, 
                                images/portfolio/notes256.png 2x"
                  alt="Notes App"
                  title="Notes App"
                />
              </div>
            </div>{' '}
            <div className="column folio-item">
              <p className="resume-block__header-meta">
                <span>Iris Machine Learning (Python, Flask, Docker)</span>
              </p>
              <a href="ml" className="folio-item__thumb">
                <img
                  src="images/portfolio/lamp.jpg"
                  srcSet="images/portfolio/lamp.jpg 1x, 
                                images/portfolio/lamp@2x.jpg 2x"
                  alt=""
                />
              </a>
            </div>
          </div>{' '}
        </section>
      </React.Fragment>
    );
  }
}
